module.exports = __webpack_public_path__ + "static/media/ng.edb0fc52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ng.svg
// module id = 209
// module chunks = 0